<template>
  <div class="manage-process">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <template #title>
        <a-row type="flex" align="middle">
          <h6 class="font-semibold m-0">Danh sách quy trình</h6>
          <router-link :to="{ name: 'CreateRecruitmentProcess' }">
            <a-button type="primary" class="ml-20">Thêm mới</a-button>
          </router-link>
        </a-row>
      </template>
      <a-table
        :columns="columns"
        :loading="callingAPI"
        :data-source="dataSource"
        :pagination="true"
        rowKey="id"
      >
        <template slot="active" slot-scope="row">
          <a-switch
            v-model="row.active"
            :loading="row.loadingActive"
            @change="handleUpdate(row)"
          />
        </template>
        <template slot="action" slot-scope="row">
          <a-space>
            <router-link
              :to="{ name: 'UpdateRecruitmentProcess', params: { id: row.id } }"
            >
              <a-button shape="circle" icon="edit" size="small" />
            </router-link>
            <a-popconfirm
              placement="topRight"
              ok-text="Xóa"
              cancel-text="Hủy"
              @confirm="remove(row)"
            >
              <template slot="title">
                <p>Xóa banner {{ row.name }} ??</p>
              </template>
              <a-button
                type="danger"
                shape="circle"
                icon="delete"
                size="small"
              />
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import { fetchProcess, updateProcess, removeProcess } from '@/services/landing-page/career/recruitment-process'
  export default {
    name: 'ManageProcess',
    data() {
      return {
        callingAPI: true,
        dataSource: [],
        columns: [
          {
            title: 'Tiêu đề',
            dataIndex: 'title',
            class: 'font-semibold',
            width: '150px'
          },
          // {
          //   title: 'Thứ tự',
          //   dataIndex: 'arrangement',
          //   scopedSlots: { customRender: 'arrangement' },
          //   width: '100px'
          // },
          {
            title: 'Nội dung',
            dataIndex: 'content',
            width: '600px'
          },
          {
            title: 'Hiển thị',
            scopedSlots: { customRender: 'active' },
            width: 100,
            fixed: "right",
          },
          {
            title: '',
            scopedSlots: { customRender: 'action' },
            width: 50,
            fixed: "right",
          },
        ]
      }
    },
    async beforeMount() {
      await this.loadData()
    },
    methods: {
      async loadData(loading = true) {
        try {
          this.callingAPI = loading
          const params = {
            post_type: 2,
            type: 3,
            per_page: 100,
          };
          const response = await fetchProcess(params)
          this.dataSource = response.data.data.map((d) =>({
            ...d,
            active: d.active === '1',
            loadingActive: false
          }))
          this.callingAPI = false
        } catch (error) {
          this.callingAPI = false
        }
      },

      async handleUpdate(row) {
        const index = this.dataSource.findIndex((r) => r.id === row.id)
        this.dataSource[index].loadingActive = true
        try {
          const data = {
            title: row.title,
            description: row.description,
            content: row.content,
            active: row.active ? '1' : '2',
            post_type: 2,
            type: 3,
            _method: 'PUT'
          }
          const response = await updateProcess(row.id, data)
          this.dataSource[index].loadingActive = false
          if (response.status === 1) {
            this.$notification.success({
              message: 'Thành công',
              description: 'Cập nhật trạng thái hiển thị thành công.',
            });
          } else {
            this.$notification.error({
              message: 'Thất bại',
              description: 'Cập nhật trạng thái hiển thị thất bại.',
            });
          }
        } catch (error) {
          this.dataSource[index].loadingActive = false
        }
      },

      async remove(row) {
        try {
          this.callingAPI = true
          const response = await removeProcess(row.id)
          if (response.status === 1) {
            this.$notification.success({
              message: 'Thành công',
              description: 'Xóa thành công',
            });
          } else {
            this.$notification.error({
              message: 'Thất bại',
              description: 'Xóa thất bại',
            });
          }
          await this.loadData()
        } catch (error) {
          this.callingAPI = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>